/* eslint-disable quotes */
import dayjs from 'dayjs';

export default {
  JAN_ALDAG: {
    fullName: 'Jan Aldag',
    image: '/assets/branches/airsoft/members/jerky.jpg',
    text: dayjs().diff('1988-09-13', 'years') + " Jahre alt\nSpartenleiter Airsoft",
    socials: {
      instagram: 'jan.gefahr'
    }
  },
  ELVAN_ELMAS: {
    fullName: 'Unbesetzt',
    image: '/assets/leading/branches/avatar_blank.svg',
    /* text: dayjs().diff('1970-01-01', 'years') + " Jahre alt\nSpartenleiter Gaming", */
    socials: {
      instagram: ''
    }
  }
};
